module.exports = __webpack_public_path__ + "static/media/Icone1-formation.68ed2cc5.svg";